import { createRoutes } from "@org-avp/avp-avengers-ui-shared-auth";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import cr from "@org-avp/avp-avengers-ui-shared-resources/public/polices/Cookie_Richtlinie_DH4ViT.pdf";
import { getRouterPath, viewRegistry } from "@org-avp/avp-avengers-ui-shared-utils";
import { HomeView } from "@org-avp/avp-avengers-ui-views-home";
import { createBrowserRouter, redirect } from "react-router-dom";
import logo from "../../public/abinaut.png";
import { AppShell } from "../components/app-shell/AppShell";
import { DetachedView } from "../components/detached-view/DetachedView";
import { RouteError } from "../components/route-error/RouteError";

export const createRouter = () => {
  return createBrowserRouter(
    createRoutes({
      errorElement: <RouteError/>,
      loginLogoElement: <img src={logo} alt="AVEnGeRS logo"/>,
      hrefDataProtectionGeneral: environment.NX_IMPRINT_DATAPROTECTION_GENERAL_URL,
      hrefDataProtectionEmployees: environment.NX_IMPRINT_DATAPROTECTION_EMPLOYEES_URL,
      hrefDataProtectionBusinessPartners: environment.NX_IMPRINT_DATAPROTECTION_BUSINESSPARTNERS_URL,
      hrefCookiePolicy: cr,
      hrefImprint: environment.NX_IMPRINT_VWAG_URL,
      unguardedRoutes: [
        {
          path: "/load-subproject/:projectId/:subprojectId",
          loader: ({ params: { projectId, subprojectId } }) => {
            return redirect(`/app/project/${projectId}/${subprojectId}`);
          },
        },
      ],
      guardedRoutes: [
        {
          path: "/",
          element: <AppShell/>,
          children: [
            ...createRoutesFromViews(),
            { path: "/", element: <HomeView/> },
          ],
        },
        {
          children: [
            ...createRoutesFromModularViews(),
          ],
        },
      ],
    }),
  );
};

const createRoutesFromModularViews = () => {
  return Array.from(viewRegistry.getViews({ type: "modular" }).values())
    .map((view) => ({
      path: getRouterPath(view),
      element: (
        <DetachedView view={view}/>
      ),
    }));
};

const createRoutesFromViews = () => {
  return Array.from(viewRegistry.getViews({ type: "fullSize" }).values())
    .map((view) => ({
      path: getRouterPath(view),
      element: view.viewEl,
    }));
};
